import { render, staticRenderFns } from "./ReservaFdExpress.vue?vue&type=template&id=5008b972&"
import script from "./ReservaFdExpress.vue?vue&type=script&lang=js&"
export * from "./ReservaFdExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports